import { defineStore } from 'pinia';
import genericAPI from "@/api/api";
import { UserFileFolder, type UserFileEntry  } from "@typesDef/user.types";
export const useUserFilesStore = defineStore('userFiles', {
    state: () => ({
        myFiles: {
            profile: null as UserFileEntry[] | null,
            event: null as UserFileEntry[] | null,
            contract: null as UserFileEntry[] | null,
            audio: null as UserFileEntry[] | null
        },
    }),
    actions: {
        clearMyData(): void {
            this.myFiles = null
        },
        /**
         * Fetch the current user from the backend
         * If force is true, the user will be fetched from the backend even if it is already in the store
         * @param force
         * @param folder - optional folder to fetch files from
         */
        async fetchCurrentUserFiles(force: boolean = false, folder: string = ""): Promise<[]> {
            log.debug(`fetchCurrentUserFiles force=${force} folder=${folder}`);
            if (!this.myFiles || (folder && !this.myFiles[folder]) || force) {
                if (folder) {
                    this.myFiles[folder] = await genericAPI.getDocument<[]>(`users/current/files/${folder}`);
                } else {
                    this.myFiles = {
                        profile: await genericAPI.getDocuments<UserFileEntry>(`users/current/files/profile`),
                        event: await genericAPI.getDocuments<UserFileEntry>(`users/current/files/event`),
                        contract: await genericAPI.getDocuments<UserFileEntry>(`users/current/files/contract`),
                        audio: await genericAPI.getDocuments<UserFileEntry>(`users/current/files/audio`)
                    }
                }
                return (folder ? this.myFiles[folder] : this.myFiles) || [];
            }
        }
    }
});
